export default {
  SHARE_CONTENTS_FETCHED: 'SHARE_CONTENTS_FETCHED',
  SHARE_CONTENT_LOAD: 'SHARE_CONTENT_LOAD',
  SHARE_CONTENT_TEMPLATES_FETCHED: 'SHARE_CONTENT_TEMPLATES_FETCHED',
  SHARE_CONTENT_TEMPLATES_LOAD: 'SHARE_CONTENT_TEMPLATES_LOAD',
  SHARE_CONTENT_DETAIL: 'SHARE_CONTENT_DETAIL',
  SHARE_CONTENT_BUTTON_LOAD: 'SHARE_CONTENT_BUTTON_LOAD',
};
